export function getIdOrCurrent<T>(entity: T & { id: number }): string {
  return entity ? entity.id.toString() : 'current';
}
